import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { loadDetailPost } from "redux/modules/postSlice";
import { getCookie } from "components/common/cookie";

import CommunityWrapper from "../main/CommunityStyle";
import DetailHeader from "./DetailHeader";
import DetailPost from "./DetailPost";

function DetailCommunity() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 토큰값 유무 확인 후, 없으면 로그인화면으로 redirect
  const isLogin = getCookie("AccessToken") ? true : false;
  useEffect(() => {
    !isLogin && navigate("/login", { replace: true });
  }, [navigate, isLogin]);

  const { boardId } = useParams(); // url의 params값(포스트ID), string

  const { detailPost, loadDetailPostLoading } = useSelector(
    (state) => state.post,
  );

  // 상세페이지 데이터 로드
  useEffect(() => {
    // console.log("디테일-홈");
    // if (loadDetailPostLoading) return null;

    dispatch(loadDetailPost(boardId));
  }, [dispatch, boardId]);

  return (
    <>
      <CommunityWrapper>
        {Object.keys(detailPost).length > 0 && (
          <>
            <DetailHeader post={detailPost} />
            <DetailPost post={detailPost} />
          </>
        )}
      </CommunityWrapper>
    </>
  );
}

export default DetailCommunity;
